module.exports = __webpack_public_path__ + "img/absence-plans.7bc80deb.svg";